// PresentersModal — per-event presenter bios rendered from markdown
// (presenters_md column). Phase 3d-1c retired the BIOS constant from
// workshop.ts; presenter photos now come from markdown image syntax
// (![alt](/presenters/file.jpg)). EventDetailPage hides the trigger
// button when content is empty.

import { Modal } from './Modal';
import { MarkdownBody } from './MarkdownBody';

interface Props {
  open: boolean;
  onClose: () => void;
  content: string;
}

export function PresentersModal({ open, onClose, content }: Props) {
  return (
    <Modal open={open} onClose={onClose} title="Meet the presenters" maxWidth="max-w-3xl">
      <div className="space-y-4">
        <MarkdownBody source={content} />
      </div>
    </Modal>
  );
}
